/* Presentation adapter only. EasySell retains all offers, pricing and order logic. */
(() => {
  function setup(root) {
    if (root.dataset.yakootaBound) return;
    root.dataset.yakootaBound = 'true';
    let scheduled = false;
    const paint = () => {
      scheduled = false;
      const slot = root.querySelector('[data-yakoota-order]');
      const app = root.querySelector('#easysell');
      if (!slot || !app || !app.querySelector('#es-form')) return;
      if (app.parentElement !== slot) slot.appendChild(app);
      root.classList.add('yakoota-app-ready');
      const style = (selector, rules) => app.querySelectorAll(selector).forEach(el => {
        Object.entries(rules).forEach(([key, value]) => {
          if (el.style.getPropertyValue(key) !== value || el.style.getPropertyPriority(key) !== 'important') el.style.setProperty(key, value, 'important');
        });
      });
      style('#es-form-container', {'background':'transparent','border-radius':'0px','color':'#171417','font-family':'Geist, sans-serif'});
      style('.es-qo-container .mb-1, .es-o-p', {'font-size':'13px','font-weight':'600','color':'#171417'});
      style('.es-offer-badge, .es-badge', {'background':'#C93F74','color':'#ffffff','font-size':'9px','font-weight':'650','border-radius':'2px'});
      style('.es-input', {'background':'#ffffff','border-radius':'0px','color':'#171417'});
      style('#es-form-button', {'background':'#C93F74','color':'#ffffff','border-radius':'2px','border-color':'#C93F74','font-size':'14px','font-weight':'700'});

      if (!app.dataset.yakootaPurchasePolishBound) {
        app.dataset.yakootaPurchasePolishBound = 'true';
      }

      const handle = (() => {
        try {
          return new URL(root.dataset.url || location.href, location.origin).pathname.split('/').filter(Boolean).pop() || '';
        } catch (_) {
          return '';
        }
      })();

      app.classList.add('yakoota-easysell-polished');

      app.querySelectorAll('.es-qo-container').forEach((offer, index) => {
        offer.classList.add('yakoota-offer-card');
        offer.dataset.yakootaOfferIndex = String(index + 1);
      });

      // Add semantic hooks based on visible labels so the app can be styled consistently
      // without changing any form values, prices or submission logic.
      app.querySelectorAll('div, p, span, label').forEach((node) => {
        if (node.children.length) return;
        const label = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;
        if (/^Total \(.*المجموع.*\)$/i.test(label) || /^Total$/i.test(label)) node.classList.add('yakoota-es-row-label');
        if (/^Livraison \(/i.test(label)) node.classList.add('yakoota-es-row-label');
        if (/Total à payer|المجموع النهائي/i.test(label)) node.classList.add('yakoota-es-total-label');
      });

      // YAKOOTA_EASYSELL_FRENCH_FREE_2026_10_01
      // Presentation-only translation: EasySell may output the English word "Free".
      // Keep order/shipping logic untouched and show French customer-facing copy.
      app.querySelectorAll('div, p, span, label, strong, b').forEach((node) => {
        if (node.children.length) return;
        const label = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Free$/i.test(label)) {
          node.textContent = 'Gratuite';
          node.dataset.yakootaTranslatedFree = 'true';
        }
      });

      // YAKOOTA_EASYSELL_SAVINGS_ROW_2026_10_02
      // Presentation only: inserts a dynamic savings row between EasySell Total and Total à payer.
      // Individuals use Shopify compare-at price; packs use the PDP reference value configured in the theme.
      const yakootaSavingsEligible = [
        'blush',
        'serum-vitamine-c',
        'creme-hydratante-vitamine-c',
        'creme-solaire-naturelle',
        'soin-booster-cils-et-sourcils',
        'poudre-blanchiment-des-dents',
        'tonique-a-la-vitamine-c-antioxydant-hydratant',
        'gel-nettoyant-a-base-de-vitamine-c',
        'detox-visage-a-la-vitamine-c',
        'savon-a-la-vitamine-c',
        'deodorant-naturel',
        'سيروم-لمحيط-العين'
      ].includes(handle) || root.dataset.yakootaPack === 'true';

      if (yakootaSavingsEligible) {
        const moneyNumber = (value) => {
          const cleaned = String(value || '').replace(/[^0-9.,-]/g, '').replace(',', '.');
          const parsed = Number.parseFloat(cleaned);
          return Number.isFinite(parsed) ? parsed : null;
        };

        const topPrice = root.querySelector('[id^="price-"]');
        const compareNode = topPrice?.querySelector('.price__sale s.price-item, .price__sale del.price-item');
        const currentNode = topPrice?.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last');
        const isPack = root.dataset.yakootaPack === 'true';

        let compareUnit = moneyNumber(compareNode?.textContent);
        let currentUnit = moneyNumber(currentNode?.textContent);

        if (isPack) {
          const packCompareCents = Number.parseFloat(root.dataset.yakootaPackCompareCents || '');
          const packCurrentCents = Number.parseFloat(root.dataset.yakootaCurrentPriceCents || '');
          compareUnit = Number.isFinite(packCompareCents) ? packCompareCents / 100 : null;
          currentUnit = Number.isFinite(packCurrentCents) ? packCurrentCents / 100 : null;

          // Keep EasySell's visible crossed-out pack reference aligned with the
          // verified sum of the current individual selling prices.
          if (compareUnit != null) {
            const compareSelectors = [
              's',
              'del',
              '[class*="old-price"]',
              '[class*="compare-price"]',
              '[class*="original-price"]',
              '[style*="line-through"]'
            ].join(',');

            app.querySelectorAll('.es-qo-container').forEach((offer) => {
              const candidates = new Set(offer.querySelectorAll(compareSelectors));

              offer.querySelectorAll('span, p, div, strong, b').forEach((node) => {
                if (node.children.length) return;
                try {
                  const decoration = getComputedStyle(node).textDecorationLine || '';
                  if (decoration.includes('line-through')) candidates.add(node);
                } catch (_) {}
              });

              candidates.forEach((node) => {
                if (node.children.length) return;
                const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
                if (!/(?:DH|MAD)/i.test(text)) return;
                const amount = moneyNumber(text);
                if (amount == null || currentUnit == null || amount <= currentUnit) return;

                node.textContent = text.replace(
                  /[0-9]+(?:[.,][0-9]{1,2})?/,
                  compareUnit.toFixed(2)
                );
                node.dataset.yakootaPackReferenceSynced = 'true';
              });
            });
          }
        }

        const selectedOffer =
          app.querySelector('.es-qo-container[offer-selected="true"]') ||
          app.querySelector('.es-qo-container[offer-selected=true]') ||
          app.querySelector('.es-qo-container[aria-checked="true"]') ||
          app.querySelector('.es-qo-container.is-selected') ||
          app.querySelector('.es-qo-container');

        const selectedText = (selectedOffer?.textContent || '').replace(/\s+/g, ' ').trim();
        const qtyMatch =
          selectedText.match(/Achetez\s+(\d+)\s+article/i) ||
          selectedText.match(/^(\d+)\s+produit/i);
        const quantity = qtyMatch ? Number.parseInt(qtyMatch[1], 10) : 1;

        const selectedOfferPrices = [];
        [
          /(?:DH|MAD)\s*([0-9]+(?:[.,][0-9]{1,2})?)/gi,
          /([0-9]+(?:[.,][0-9]{1,2})?)\s*(?:DH|MAD)/gi
        ].forEach((pattern) => {
          let match;
          while ((match = pattern.exec(selectedText))) {
            const parsed = moneyNumber(match[1]);
            if (parsed != null) selectedOfferPrices.push(parsed);
          }
        });
        const selectedOfferTotal =
          selectedOfferPrices.length > 0
            ? selectedOfferPrices[selectedOfferPrices.length - 1]
            : (currentUnit != null ? currentUnit * quantity : null);

        const totalContainer = app.querySelector('.total-container');
        if (totalContainer && compareUnit != null && selectedOfferTotal != null) {
          const compareTotal = compareUnit * (isPack ? 1 : quantity);
          const saving = Math.max(0, Math.round(compareTotal - selectedOfferTotal));

          let savingRow = totalContainer.querySelector('.yakoota-es-saving-row');
          if (!savingRow) {
            savingRow = document.createElement('div');
            savingRow.className = 'yakoota-es-saving-row';
            savingRow.innerHTML = '<span class="yakoota-es-saving-label">Économisez</span><strong class="yakoota-es-saving-value"></strong>';

            let payLabel = null;
            totalContainer.querySelectorAll('div, p, span, label').forEach((node) => {
              if (payLabel || node.children.length) return;
              const txt = (node.textContent || '').replace(/\s+/g, ' ').trim();
              if (/Total à payer|المجموع النهائي/i.test(txt)) payLabel = node;
            });

            const payRow = payLabel?.parentElement;
            if (payRow && payRow.parentElement === totalContainer) {
              totalContainer.insertBefore(savingRow, payRow);
            } else if (payRow && totalContainer.contains(payRow)) {
              payRow.insertAdjacentElement('beforebegin', savingRow);
            } else {
              totalContainer.appendChild(savingRow);
            }
          }

          const value = savingRow.querySelector('.yakoota-es-saving-value');
          if (value) value.textContent = '-' + saving + ' DH';
          savingRow.hidden = saving <= 0;
        }

        if (!app.dataset.yakootaSavingsRefreshBound) {
          app.dataset.yakootaSavingsRefreshBound = 'true';
          const refresh = () => {
            if (!scheduled) {
              scheduled = true;
              requestAnimationFrame(paint);
            }
          };
          app.addEventListener('click', () => setTimeout(refresh, 0));
          app.addEventListener('change', () => setTimeout(refresh, 0));
        }
      }

      // Shorten only the visible product name inside the EasySell offer card.
      // The linked product/variant/order data is untouched.
      app.querySelectorAll('a').forEach((link) => {
        const href = link.getAttribute('href') || '';
        const label = (link.textContent || '').replace(/\s+/g, ' ').trim();
        if (handle === 'pack-duo-pour-le-visage' && /pack duo pour le visage/i.test(label)) {
          link.dataset.yakootaOriginalLabel = label;
          link.textContent = 'Pack Duo Visage';
          link.classList.add('yakoota-offer-title');
          if (!link.parentElement?.querySelector('.yakoota-offer-subtitle')) {
            const sub = document.createElement('span');
            sub.className = 'yakoota-offer-subtitle';
            sub.textContent = 'Sérum vitamine C + Crème hydratante';
            link.insertAdjacentElement('afterend', sub);
          }
        } else if (handle === 'blush' && /blush concentr/i.test(label)) {
          link.classList.add('yakoota-offer-title');
        }
      });

      app.querySelectorAll('button,input[type="button"],input[type="submit"]').forEach((secondaryButton) => {
        const secondaryLabel = ((secondaryButton.textContent || '') || (secondaryButton.value || '')).replace(/\s+/g,' ').trim();
        if (/^Appliquer$/i.test(secondaryLabel)) {
          secondaryButton.classList.add('yakoota-es-apply');
          secondaryButton.dataset.yakootaEsApplyBound = 'true';
        }
      });

      app.querySelectorAll('input').forEach((promoInput) => {
        const marker = ((promoInput.placeholder || '') + ' ' + (promoInput.name || '') + ' ' + (promoInput.id || '')).toLowerCase();
        if (!marker.includes('promo')) return;
        const scope = promoInput.parentElement;
        if (!scope) return;
        const promoButton = scope.querySelector('button,input[type="button"],input[type="submit"]');
        if (!promoButton || promoButton === promoInput) return;
        promoButton.classList.add('yakoota-es-apply');
        promoButton.dataset.yakootaEsApplyBound = 'true';
        if (promoButton.tagName === 'INPUT') {
          promoButton.value = 'Appliquer';
        } else if (!(promoButton.textContent || '').trim()) {
          promoButton.textContent = 'Appliquer';
        }
      });

      const existingReassurance = app.querySelector('.yakoota-easysell-reassurance');
      if (existingReassurance && existingReassurance.dataset.yakootaReassuranceVersion !== '2') {
        existingReassurance.remove();
      }

      const button = app.querySelector('#es-form-button');
      if (button && !app.querySelector('.yakoota-easysell-reassurance')) {
        const reassurance = document.createElement('div');
        reassurance.className = 'yakoota-easysell-reassurance';
        reassurance.dataset.yakootaReassuranceVersion = '2';
        reassurance.setAttribute('aria-label', 'Informations de paiement et livraison');
        const isPack = root.dataset.yakootaPack === 'true';
        reassurance.innerHTML = isPack
          ? '<div class="yakoota-reassurance-row"><strong>Paiement à la livraison</strong><small lang="ar" dir="rtl">كتخلصي ملي يوصلك الطلب</small></div><div class="yakoota-reassurance-row"><strong>Livraison sous 48h</strong><small lang="ar" dir="rtl">التوصيل فـ 48 ساعة</small></div><div class="yakoota-reassurance-row yakoota-reassurance-row--shipping"><strong>Livraison gratuite</strong><small lang="ar" dir="rtl">التوصيل مجاني مع هاد الباك</small></div>'
          : '<div class="yakoota-reassurance-row"><strong>Paiement à la livraison</strong><small lang="ar" dir="rtl">كتخلصي ملي يوصلك الطلب</small></div><div class="yakoota-reassurance-row"><strong>Livraison sous 48h</strong><small lang="ar" dir="rtl">التوصيل فـ 48 ساعة</small></div><div class="yakoota-reassurance-row yakoota-reassurance-row--shipping"><strong>1 produit : +15 DH · 2 produits ou + : livraison gratuite</strong><small lang="ar" dir="rtl">منتوج واحد 15 درهم · من جوج منتجات التوصيل مجاني</small></div>';
        button.insertAdjacentElement('afterend', reassurance);
      }
    };
    const observer = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(paint); } });
    observer.observe(root, {childList:true, subtree:true});
    paint();
    document.addEventListener('shopify:section:unload', e => { if (e.target.contains(root)) observer.disconnect(); });
  }
  const init = () => document.querySelectorAll('.yakoota-product').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();

/* Sticky purchase bar — desktop + mobile. EasySell remains the primary COD checkout. */
(() => {
  const moneyLabel = value => {
    if (!value) return '';
    const numeric = Number(String(value).replace(',', '.'));
    if (!Number.isFinite(numeric)) return '';
    const clean = Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(2).replace(/\.00$/, '');
    return clean + ' DH';
  };

  const extractPrices = text => {
    const values = [];
    const source = String(text || '');
    const patterns = [
      /(?:DH|MAD)\s*([0-9]+(?:[.,][0-9]{1,2})?)/gi,
      /([0-9]+(?:[.,][0-9]{1,2})?)\s*(?:DH|MAD)/gi
    ];
    patterns.forEach(pattern => {
      let match;
      while ((match = pattern.exec(source))) values.push(match[1]);
    });
    return values;
  };

  const init = () => document.querySelectorAll('.yakoota-product').forEach(root => {
    if (root.dataset.yakootaStickyBound) return;
    root.dataset.yakootaStickyBound = 'true';

    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const isPack = root.dataset.yakootaPack === 'true';

    const bar = document.createElement('div');
    bar.className = 'yakoota-sticky-purchase';
    bar.hidden = true;

    const media = document.createElement('div');
    media.className = 'yakoota-sticky-purchase__media';

    const sourceImage = root.querySelector('media-gallery img, .product__media img, .product-media-container img');
    if (sourceImage) {
      const image = document.createElement('img');
      image.className = 'yakoota-sticky-purchase__image';
      image.src = sourceImage.currentSrc || sourceImage.src;
      image.alt = sourceImage.alt || root.querySelector('.product__title h1')?.textContent?.trim() || 'Produit Yakoota';
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      media.hidden = true;
    }

    const meta = document.createElement('div');
    meta.className = 'yakoota-sticky-purchase__meta';

    const title = document.createElement('span');
    title.className = 'yakoota-sticky-purchase__title';
    title.textContent = root.querySelector('.product__title h1')?.textContent?.trim() || 'Produit Yakoota';

    const price = document.createElement('strong');
    price.className = 'yakoota-sticky-purchase__price';

    const shipping = document.createElement('small');
    shipping.className = 'yakoota-sticky-purchase__shipping';

    meta.append(title, price, shipping);

    const actions = document.createElement('div');
    actions.className = 'yakoota-sticky-purchase__actions';

    const cartButton = document.createElement('button');
    cartButton.type = 'button';
    cartButton.className = 'yakoota-sticky-purchase__cart';
    cartButton.textContent = 'AJOUTER AU PANIER';
    cartButton.setAttribute('aria-label', isPack ? 'Ajouter ce pack au panier' : 'Ajouter ce produit au panier');

    const orderButton = document.createElement('button');
    orderButton.type = 'button';
    orderButton.className = 'yakoota-sticky-purchase__order';
    orderButton.textContent = isPack ? 'COMMANDER LE PACK · طلبي الباك' : 'COMMANDER · طلبي دابا';
    orderButton.setAttribute('aria-label', isPack ? 'Commander ce pack' : 'Commander ce produit');

    actions.append(cartButton, orderButton);
    bar.append(media, meta, actions);
    document.body.append(bar);

    let main, frame = 0, returning = false, returnTimer, selectedQuantity = 1, cartResetTimer;

    const editable = el => el instanceof Element && !!el.closest('input, textarea, select, [contenteditable="true"]');

    const visible = el => {
      if (!el || !el.isConnected || !el.getClientRects().length) return false;
      const r = el.getBoundingClientRect();
      const v = window.visualViewport;
      const top = v ? v.offsetTop : 0;
      const bottom = top + (v ? v.height : innerHeight);
      return r.width > 0 && r.height > 0 && r.bottom > top && r.top < bottom;
    };

    const fallbackPrice = () => {
      const el = root.querySelector('.price-item--sale, .price__sale .price-item--regular, .price-item--regular');
      const values = extractPrices(el?.textContent || '');
      return moneyLabel(values[values.length - 1]);
    };

    const syncOffer = () => {
      const app = root.querySelector('#easysell');
      const selected = app?.querySelector(
        '.es-qo-container[offer-selected="true"], .es-qo-container[offer-selected=true], .es-qo-container[aria-checked="true"], .es-qo-container.is-selected'
      );

      const offerText = selected?.innerText || selected?.textContent || '';
      const prices = extractPrices(offerText);
      const currentPrice = moneyLabel(prices[prices.length - 1]) || fallbackPrice();

      if (currentPrice && price.textContent !== currentPrice) price.textContent = currentPrice;

      const qtyMatch = offerText.match(/Achetez\s+(\d+)\s+article/i);
      selectedQuantity = qtyMatch ? Math.max(1, Number.parseInt(qtyMatch[1], 10) || 1) : 1;

      const freeShipping = isPack || /livraison\s+(?:gratuite|offerte)|free\s+shipping/i.test(offerText);
      const shippingText = freeShipping ? 'Livraison gratuite · التوصيل مجاني' : '+15 DH livraison · التوصيل 15 درهم';
      if (shipping.textContent !== shippingText) shipping.textContent = shippingText;

      const aria = currentPrice
        ? `${isPack ? 'Commander ce pack' : 'Commander'} — ${currentPrice}${freeShipping ? ', livraison gratuite' : ', plus 15 DH de livraison'}`
        : (isPack ? 'Commander ce pack' : 'Commander ce produit');
      orderButton.setAttribute('aria-label', aria);
    };

    const update = () => {
      frame = 0;
      const next = root.querySelector('#es-form-button');
      if (next !== main) {
        if (main) intersection.unobserve(main);
        main = next;
        if (main) intersection.observe(main);
      }

      syncOffer();

      const form = root.querySelector('form.es-form');
      const fieldsVisible = form && [...form.querySelectorAll('input:not([type="hidden"]), textarea, select')].some(visible);
      const keyboard = mobile.matches && visualViewport && innerHeight - visualViewport.height > 120;

      bar.hidden =
        !main ||
        !form ||
        main.disabled ||
        visible(main) ||
        fieldsVisible ||
        editable(document.activeElement) ||
        keyboard ||
        returning;
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    const intersection = new IntersectionObserver(schedule, {threshold:[0,1]});
    const mutations = new MutationObserver(schedule);
    mutations.observe(root, {childList:true, subtree:true, characterData:true, attributes:true});

    const finishReturn = () => {
      returning = false;
      schedule();
    };

    orderButton.addEventListener('click', () => {
      const area = root.querySelector('[data-yakoota-order]');
      if (!area) return;
      returning = true;
      bar.hidden = true;
      area.setAttribute('tabindex','-1');
      area.focus({preventScroll:true});
      area.scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth', block:'start'});
      clearTimeout(returnTimer);
      returnTimer = setTimeout(finishReturn,1200);
    });

    cartButton.addEventListener('click', async () => {
      const variantInput = root.querySelector('input[name="id"][value]');
      const variantId = Number.parseInt(variantInput?.value || '', 10);
      if (!Number.isFinite(variantId)) return;

      clearTimeout(cartResetTimer);
      const defaultLabel = 'AJOUTER AU PANIER';
      cartButton.disabled = true;
      cartButton.textContent = 'AJOUT...';

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:variantId, quantity:selectedQuantity}]})
        });

        if (!response.ok) throw new Error('Cart add failed');

        cartButton.textContent = 'AJOUTÉ ✓';
        cartButton.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));

        cartResetTimer = setTimeout(() => {
          cartButton.textContent = defaultLabel;
          cartButton.classList.remove('is-added');
          cartButton.disabled = false;
        }, 1800);
      } catch (_) {
        cartButton.textContent = 'RÉESSAYER';
        cartResetTimer = setTimeout(() => {
          cartButton.textContent = defaultLabel;
          cartButton.disabled = false;
        }, 1800);
      }
    });

    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    document.addEventListener('focusin',schedule);
    document.addEventListener('focusout',schedule);
    mobile.addEventListener('change',schedule);
    window.visualViewport?.addEventListener('resize',schedule);
    window.visualViewport?.addEventListener('scroll',schedule);

    const unload = event => {
      if (!event.target.contains(root)) return;
      intersection.disconnect();
      mutations.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(returnTimer);
      clearTimeout(cartResetTimer);
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',schedule);
      document.removeEventListener('focusin',schedule);
      document.removeEventListener('focusout',schedule);
      mobile.removeEventListener('change',schedule);
      window.visualViewport?.removeEventListener('resize',schedule);
      window.visualViewport?.removeEventListener('scroll',schedule);
      bar.remove();
      delete root.dataset.yakootaStickyBound;
      document.removeEventListener('shopify:section:unload',unload);
    };

    document.addEventListener('shopify:section:unload',unload);
    schedule();
  });

  init();
  document.addEventListener('shopify:section:load',init);
})();

// Yakoota FAQ accordion
document.addEventListener('click',function(event){var button=event.target.closest('.yakoota-faq__question');if(!button)return;var item=button.closest('.yakoota-faq__item');var list=item&&item.parentElement;if(!item||!list)return;list.querySelectorAll('.yakoota-faq__question').forEach(function(other){if(other!==button){other.setAttribute('aria-expanded','false');var panel=document.getElementById(other.getAttribute('aria-controls'));if(panel)panel.hidden=true;var icon=other.querySelector('span:last-child');if(icon)icon.textContent='+';}});var panel=document.getElementById(button.getAttribute('aria-controls'));var open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));if(panel)panel.hidden=open;var icon=button.querySelector('span:last-child');if(icon)icon.textContent=open?'+':'−';});











